// extracted by mini-css-extract-plugin
export default {"mainLabelContainer":"gi4NnIhi5W33Atgb3rh7","mainLabelWrapper":"XQI6ZlitHKnMFmajwTOf","depositLabel":"HPG9X3YCBP2dNPw0Vigb","mainLabelSkeleton":"sx2WhY1CDVKUdy_jdM4K","mainLabel":"IEc9WSOywIRyMtFpxg_k","mainGetLabel":"Ta68tg1XKB_ZLdit96PV","middle":"Zy3L3YYxlYvPGqDDNmyV","last":"zLlaEpsnmer4WK_AKyu1","label":"zvaBgdUz4sbzuKQQNxFn","noWageringWrapper":"ixfcoRo3iCfjvrGZriOz","bodyS":"caMFg3z_2voyHhYMfrI5","noWageringLink":"zNSdFPEzZMvgPYMSAL9S","h1":"kzt7UNt_l5t_Qiud70B_","parallaxContainer":"NsgKmqBtfcUWbgqTgJWb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"mainLabelContainer\":\"gi4NnIhi5W33Atgb3rh7\",\"mainLabelWrapper\":\"XQI6ZlitHKnMFmajwTOf\",\"depositLabel\":\"HPG9X3YCBP2dNPw0Vigb\",\"mainLabelSkeleton\":\"sx2WhY1CDVKUdy_jdM4K\",\"mainLabel\":\"IEc9WSOywIRyMtFpxg_k\",\"mainGetLabel\":\"Ta68tg1XKB_ZLdit96PV\",\"middle\":\"Zy3L3YYxlYvPGqDDNmyV\",\"last\":\"zLlaEpsnmer4WK_AKyu1\",\"label\":\"zvaBgdUz4sbzuKQQNxFn\",\"noWageringWrapper\":\"ixfcoRo3iCfjvrGZriOz\",\"bodyS\":\"caMFg3z_2voyHhYMfrI5\",\"noWageringLink\":\"zNSdFPEzZMvgPYMSAL9S\",\"h1\":\"kzt7UNt_l5t_Qiud70B_\",\"parallaxContainer\":\"NsgKmqBtfcUWbgqTgJWb\"}";
        // 1755964992836
        var cssReload = require("../../../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  